import React from "react";
import { formatINR } from "@/lib/api";

const SizeSelector = ({ sizes = [], value, onChange }) => {
    if (!sizes.length) return null;
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="size-selector">
            {sizes.map((s) => {
                const selected = value?.label === s.label;
                return (
                    <button
                        key={s.label}
                        onClick={() => onChange(s)}
                        disabled={s.active === false}
                        className={`relative p-3 rounded-2xl border transition-all text-left disabled:opacity-40 ${
                            selected ? "border-primary bg-primary/10 shadow-md" : "border-border bg-white/40 hover:border-primary/40"
                        }`}
                        data-testid={`size-option-${s.label.replace(/\s+/g, "-").toLowerCase()}`}
                    >
                        <div className="font-display text-lg font-bold">{s.label}</div>
                        <div className="text-xs text-muted-foreground">{s.weight_grams}g · 4–5d delivery</div>
                        <div className="mt-2 font-semibold text-primary">{formatINR(s.price_inr)}</div>
                        {selected && <span className="absolute top-2 right-2 w-2.5 h-2.5 rounded-full bg-primary" />}
                    </button>
                );
            })}
        </div>
    );
};

export default SizeSelector;
